import { BUTTON_LOADER } from "../actions/actionConstants";

const initialState={
    activityAssignee: false,
    publishNote: false,
    changeOwner: false,
    activityTemplate: false,
    newLog: false,
    createDiary: false,
    createActivity:false,
    contactInsured:false,
    contactRelationType: false
}

export default function (state = initialState, action) {
    switch (action.type) {
        case BUTTON_LOADER:{
            return Object.assign({}, state, action.payload);
        }
        default:
            return state;
    }
}